export default {
  notifications: [],
  notifications_errors: [],
  notifications_loading: false,
  notification_detail: {},
  notification_detail_errors: [],
  notification_detail_loading: false,
};
